import TrackThumbnail from "components/TrackThumbnail.js";
import UnsourcedFlow from './UnsourcedFlow.js';
import ContextualHelp from "components/sidebar/ContextualHelpComponent.js";
import SampleUsed from './SampleUsed.js';
import SaveNewSample from './SaveNewSample.js';
import Rating from './Rating.js';
import {SOUND_RATED} from 'decentralized/xanadu/LinkTypes.js';
import SynthBrowser from './SynthBrowser.js';
import SamplesBreadcrumb from './SamplesBreadcrumb.js';
import Colors from 'components/Colors.js';
import Waveform from 'components/Waveform.js';
import AnnotationEdit from "components/explore/links/AnnotationEdit.js"
import {SAMPLE_ANNOTATION} from 'constants/annotation-types.js';
import {WAVEFORM, PIANO_ROLL, INFO} from 'constants/arrangement-modes.js';
import AudioUnit from 'engine/audio.js';
import TagsInfo from './TagsInfo.js';
import GoToSource from './GoToSource.js';
import CreatedBy from './CreatedBy.js';
import {SEQUENCER_VIEW} from "constants/view-modes.js";
import React, { useEffect, useCallback, useState} from 'react';
import DetailsView from 'components/DetailsView.js';
import {SAMPLER, SAMPLED_INSTRUMENT, MULTI_SYNTH} from "constants/instrument-types.js";
import {INSTRUMENT_RACK, MULTI_FREEZE} from "constants/track-types.js";
import SampleExplorer from './SampleExplorer.js';
import {connect} from 'react-redux';
import '../../SamplerBrowser.scss';

const colors = new Colors();

const SamplerBrowser = ({bottomMode, track, sequencerEngine, id, loaded, selectedInstrument, isFrozen}) => { 
    let [tagSelected, setTagSelected] = useState(undefined);
    let [audioUnit, setAudioUnit] = useState(new AudioUnit());


   useEffect(() => {
        return () => audioUnit.dispose();
    }, [audioUnit]);

    if (track === undefined) {
        return (
           <div></div>
        );
    }

    if (bottomMode === WAVEFORM && (
        track.getTrackType() === SAMPLER ||
            track.isFrozen ||
            track.getTrackType() === MULTI_FREEZE)) {
        return (
            <DetailsView.DetailsView
              showParameters={false}
              hideKeyboard={false}
              alreadyLoaded={true}
              onGoBack={() => []}
              keyboardEngine={sequencerEngine.keyboardEngine}
              midiEngine={sequencerEngine.midi}
              trackNumber={sequencerEngine.cursor.track}
              resolution={sequencerEngine.resolution}
              parentView={SEQUENCER_VIEW}
              sequencerEngine={sequencerEngine}
              bpm={sequencerEngine.bpm}
              track={track}/>
        );
    }
        
    let sample = undefined
    let subTrack = track;
    let sampler= undefined;
    let instrument = undefined;

    if (track.getTrackType() === SAMPLER) {
        sample = track.sample;
        if (sample !== undefined) {
            sampler = track.samplers[sample.getId()];
        }
    } else if (track.instrument && track.instrument.getInstrumentType() === SAMPLED_INSTRUMENT) {
        sampler = track.selectedSampler || track.instrument.defaultSampler;
        if (sampler) {
            sample = sampler.sample;
        }
        instrument = track.instrument;
    } else if (track.instrument && track.instrument.getInstrumentType() === MULTI_SYNTH) {
        instrument = track.instrument;
    } else if (track.instrument && track.getTrackType() === INSTRUMENT_RACK &&
              track.tracks.length > 0) {
        let t = selectedInstrument ? selectedInstrument.track : track.tracks[0].track;
        if (t.instrument.getInstrumentType() === SAMPLED_INSTRUMENT) {
            sampler = 
                t.selectedSampler || t.instrument.defaultSampler;
            if (sampler !== undefined) {
                sample = sampler.sample;
                subTrack = t;
            }
        } else if (t.instrument.getInstrumentType() === MULTI_SYNTH) {
            instrument = t.instrument;
            subTrack = t;
        }
    };

    if (instrument && !subTrack.isFrozen) {
        return (
            <SynthBrowser
              type={instrument.getInstrumentType()}
              tagSelected={tagSelected}
              setTagSelected={setTagSelected}
              synth={instrument}
              track={subTrack}/>
        );
    }

    if (sample === undefined ||
        sample.audioBuffer === undefined ||
        track.isFrozen) {
        return (
            <div>
            </div>);
    }

    audioUnit.setBuffer(sample.audioBuffer);

    let t = subTrack || track;
    let color = colors.getColorForTrack(t);


    return (
        <div
          className="sampler-browser">
          <div>
            <TrackThumbnail 
              track={track}
              sample={sample}
              onClickThumbnail={() => []}
              />
            <Waveform
              audioUnit={audioUnit}
              sequencerEngine={sequencerEngine}
              buffer={sample.audioBuffer}
              id={sample.ipfsHash}
              sample={sample}
              width={100}
              height={30}/>
            <SamplesBreadcrumb sample={sample} track={subTrack}/>
          </div>
          <div className="sample-info">
            <div className="name-info">
              <div className="sample-name">{truncateName(sample.name)}</div>
              {sample.needsSave ? 'Not saved yet' : 
               <div>
                 <CreatedBy content={sample}/>
                 <GoToSource sample={sample}/>
               </div>
              }
            </div>
            <TagsInfo
              tagSelected={tagSelected}
              setTagSelected={setTagSelected}
              content={sample}/>
            <Rating
              color={color}
              content={sample.ipfsHash}
              type={SOUND_RATED}/>
          </div>
          <div>
            <UnsourcedFlow track={track} sample={sample}/>
            <SampleUsed sequencerEngine={sequencerEngine} sample={sample}/>
          </div>
          {!sample.needsSave ? 
          <SampleExplorer
            audioUnit={audioUnit}
            setTagSelected={setTagSelected}
            tagSelected={tagSelected}
            track={subTrack}
            sample={sample}/> 
           :
           <SaveNewSample track={track} sample={sample}/>
          }
         <ContextualHelp sequencerEngine={sequencerEngine}/>
        </div>);
}

function truncateName(name) {
    if (name === undefined) {
        return "";
    }
    name = name.trim();
    if (name.length > 40) {
        return name.substring(0, 40) + '...';
    }
    return name;
}


const mapStateToProps = (state, props) => {
    let track = props.track;
    if (track === undefined) {
        return {
            selectedInstrument: undefined,
            loaded: false,
        };
    }
    return {
        playing: track.frozenColumns && track.frozenColumns[0].playing,
        selectedInstrument: state.tracks.selectedRackSubTrack[props.track.id],
        loaded: state.tracks.trackIsLoading[props.track.subSequence.id] &&
            !state.tracks.trackIsLoading[props.track.subSequence.id][props.track.trackNumber],
        isFrozen: track.isFrozen,
        
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SamplerBrowser);
